<template>
  <div class="mt-2">
    <div class="tabs">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a
            class="nav-link active"
            data-bs-target="#details"
            href="#details"
            data-bs-toggle="tab"
            >Detalji</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            data-bs-target="#articles"
            href="#articles"
            data-bs-toggle="tab"
            >Proizvodi</a
          >
        </li>
      </ul>

      <div class="tab-content">
        <div id="details" class="tab-pane active">
          <!-- start: page -->
          <form
            class="ecommerce-form action-buttons-fixed"
            @submit.prevent="submitForm"
            novalidate
          >
            <div class="row">
              <div class="col">
                <section class="card card-modern card-big-info">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-2-5 col-xl-1-5">
                        <i class="card-big-info-icon bx bx-slider"></i>
                        <h2 class="card-big-info-title">Detalji</h2>
                      </div>
                      <div class="col-lg-3-5 col-xl-4-5">
                        <div
                          class="form-group row align-items-center mb-3"
                          :class="{
                            'has-danger':
                              $v.category.title.$invalid && $v.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Naziv</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              placeholder="Title"
                              v-model="category.title"
                            />
                            <form-error
                              :model="$v.category.title"
                              :dirty="$v.$dirty"
                              label="Naziv"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center mb-3"
                          :class="{
                            'has-danger':
                              $v.category.description.$invalid && $v.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Opis</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <textarea
                              class="form-control"
                              rows="3"
                              v-model="category.description"
                            ></textarea>

                            <form-error
                              :model="$v.category.description"
                              :dirty="$v.$dirty"
                              label="Opis"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Nadredjena kategorija</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <treeselect
                              v-model="category.parentCategoryId"
                              :multiple="false"
                              :options="categories"
                              :show-count="true"
                              placeholder="Izaberite kategoriju"
                              v-if="categories"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center mb-3"
                          :class="{
                            'has-danger':
                              $v.category.order.$invalid && $v.$dirty,
                          }"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Prioritet</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="number"
                              class="form-control form-control-modern"
                              placeholder="Prioritet"
                              min="0"
                              v-model="category.order"
                            />
                            <form-error
                              :model="$v.category.order"
                              :dirty="$v.$dirty"
                              label="Prioritet"
                            />
                          </div>
                        </div>

                        <div
                          class="form-group row align-items-center mb-3"
                          v-if="category.imageUrl"
                        >
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Slika</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <div class="popup-gallery row">
                              <div class="img-fluid">
                                <img
                                  class="img-thumbnail"
                                  :src="`${baseUrl}${category.imageUrl}`"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Slika kategorije</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="file"
                              class="form-control form-control-modern"
                              ref="photo"
                              accept="image/*"
                            />
                            <span class="form-text">
                              Učitajte sliku rezolucije 400px x 320px
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
                <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-tag"></i>
                  <h2 class="card-big-info-title">{{ translations.metaSeoDetails }}</h2>
                  <p class="card-big-info-desc">
                    {{ translations.metaSeo }}
                  </p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Naslov</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="category.metaSeo.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Opis</label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Opis"
                        v-model="category.metaSeo.description"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Keyword</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Keyword"
                        v-model="category.metaSeo.keyword"
                      />
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </section>
              </div>
            </div>
            <div class="action-buttons d-flex justify-content-between">
              <div>
                <button
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                  class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                >
                  <i class="bx bx-trash text-4 me-2"></i>
                  {{ translations.delete }}
                </button>
              </div>
              <div class="d-flex gap-3">
                <router-link
                  exact
                  :to="{ name: 'Categories' }"
                  class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
                >
                  {{ translations.cancel }}
                </router-link>
                <button
                  type="submit"
                  class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                >
                  <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
                </button>
              </div>
            </div>
            <modal id="delete-modal">
              <h5 slot="header">
                <strong>{{ translations.deleteCategory }}</strong>
              </h5>
              <div slot="body">
                <span v-html="modalText"> </span>
              </div>
              <div slot="footer">
                <div class="row">
                  <div class="col-md-12 text-end">
                    <button
                      type="button"
                      class="btn btn-primary px-4 mx-2"
                      @click.prevent.stop="deleteCategory"
                      data-bs-dismiss="modal"
                    >
                      {{ translations.yes }}
                    </button>
                    <button
                      type="button"
                      class="btn btn-default px-4"
                      data-bs-dismiss="modal"
                    >
                      {{ translations.no }}
                    </button>
                  </div>
                </div>
              </div>
            </modal>
          </form>
        </div>
        <div id="articles" class="tab-pane">
          <div class="ecommerce-form action-buttons-fixed">
            <div class="row">
              <div class="col">
                <section class="card card-modern card-big-info">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-lg-2-5 col-xl-1-5">
                        <i class="card-big-info-icon bx bx-slider"></i>
                        <h2 class="card-big-info-title">Article Details</h2>
                      </div>
                      <div class="col-lg-3-5 col-xl-4-5">
                        <div class="form-group row align-items-center pb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Artikal</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <treeselect
                              v-model="articleForm.articleId"
                              :multiple="false"
                              :options="articles"
                              placeholder="Izaberite artikal"
                              :async="true"
                              loadingText="Učitavanje..."
                              noResultsText="Nema rezultata"
                              searchPromptText="Unesite naziv artikla"
                              :load-options="loadArticles"
                            />
                          </div>
                        </div>

                        <div class="form-group row align-items-center mb-3">
                          <label
                            class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                            >Redoslijed</label
                          >
                          <div class="col-lg-7 col-xl-6">
                            <input
                              type="text"
                              class="form-control form-control-modern"
                              placeholder="Redoslijed"
                              v-model.number="articleForm.order"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div
              class="dataTables_wrapper dt-bootstrap5 no-footer"
              v-if="priorityArticles.length > 0"
            >
              <div class="table-responsive">
                <table
                  class="table table-ecommerce-simple table-striped mb-0 dataTable no-footer"
                >
                  <thead>
                    <tr role="row">
                      <th class="sorting">Rbr</th>
                      <th class="sorting">Naziv artikla</th>
                      <th class="sorting">Redoslijed</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      role="row"
                      v-for="(item, index) in priorityArticles"
                      :key="item.articleId"
                      :class="{ odd: index % 2 === 0, even: index % 2 !== 0 }"
                    >
                      <td>
                        <strong>{{ index + 1 }}</strong>
                      </td>
                      <td>{{ item.article }}</td>
                      <td>
                        <input
                          type="number"
                          class="form-control"
                          v-model.number="item.articlePriorityOrder"
                        />
                      </td>
                      <td>
                        <i
                          class="fa fa-trash"
                          role="button"
                          @click="deleteArticle(item.id)"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="action-buttons d-flex justify-content-end">
              <div class="d-flex gap-3">
                <button
                  @click="saveArticlePriority"
                  type="button"
                  class="submit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
                >
                  <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end: page -->
  </div>
</template>

<script>
import { debounce } from 'lodash';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import config from '@/config';
import api from '@/services/api';
import validations from './validation-schema/add';
import FormError from '../shared/form-errors/FormError.vue';
import Modal from '../shared/modal/Modal.vue';

export default {
  components: { FormError, Treeselect, Modal },
  name: 'EditCategory',
  mixins: [translations],
  validations: {
    category: {
      ...validations,
    },
  },
  data() {
    return {
      baseUrl: config.baseUrl,
      category: {
        id: null,
        title: '',
        description: '',
        parentCategoryId: null,
        order: null,
        imageUrl: null,
        metaSeo: {
          title: null,
          description: null,
          keyword: null,
        },
      },
      articleForm: {
        order: null,
        articleId: null,
      },
    };
  },
  watch: {
    storeCategory: {
      immediate: true,
      handler(selectedCategory) {
        if (!selectedCategory || !selectedCategory.id) {
          return;
        }
        this.category = {
          ...selectedCategory,
          metaSeo: selectedCategory.metaSeo
            ? { ...selectedCategory.metaSeo }
            : { title: null, description: null, keyword: null },
        };
      },
    },
  },
  computed: {
    modalText() {
      return this.translations.areYouSureCategory.replace(
        '{category}',
        `<strong>${this.category.title}</strong>`
      );
    },
    categories() {
      return this.$store.getters.getCategoriesTree;
    },
    storeCategory() {
      return this.$store.getters.getCategory;
    },
    articles() {
      return this.$store.getters.getCategoryArticles;
    },
    priorityArticles() {
      return this.$store.getters.getPriorityArticles;
    },
  },
  methods: {
    submitForm() {
      this.$v.$touch();
      const { title, description, parentCategoryId, id, order } = this.category;

      const formData = new FormData();

      formData.append('id', id);
      formData.append('title', title);
      formData.append('description', description);
      formData.append('order', order);

      if (this.$refs.photo.files[0]) {
        formData.append('Image', this.$refs.photo.files[0]);
      }

      if (parentCategoryId) {
        formData.append('parentCategoryId', parentCategoryId);
      }

      if (this.category.metaSeo.title) {
        formData.append('metaSeo.title', this.category.metaSeo.title);
      }

      if (this.category.metaSeo.description) {
        formData.append('metaSeo.description', this.category.metaSeo.description);
      }

      if (this.category.metaSeo.keyword) {
        formData.append('metaSeo.keyword', this.category.metaSeo.keyword);
      }

      if (!this.$v.$invalid) {
        api
          .updateCategory(formData)
          .then((response) => {
            this.$toast.info(response.data.info);
            this.$router.push({ name: 'Categories' });
          })
          .catch((err) => {
            this.$toast.error(err.response.data.info);
          });
      } else {
        this.$toast.error(this.translations.forms.notValid);
      }
    },
    deleteCategory() {
      api
        .deleteCategories([this.category.id])
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'Categories' });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
        });
    },
    saveArticlePriority() {
      const payload = [...this.priorityArticles];

      if (this.articleForm.articleId) {
        payload.push({
          articleId: this.articleForm.articleId,
          categoryId: this.category.id,
          articlePriorityOrder: this.articleForm.order,
        });
      }

      api
        .saveArticlesPriority(payload)
        .then((response) => {
          this.articleForm.articleId = null;
          this.articleForm.order = null;
          this.$toast.info(response.data.info);

          this.$store.dispatch('getPriorityArticles', {
            categoryId: this.category.id,
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    loadArticles({ callback, searchQuery }) {
      const handleSearch = debounce(() => {
        this.$store
          .dispatch('getCategoryArticles', {
            isSortAscending: true,
            retrieveAll: true,
            quickSearch: searchQuery,
            categoryId: this.category.id,
            sortBy: 'createdDate',
          })
          .then(() => {
            callback(null, this.articles);
          });
      }, 3000);
      handleSearch();
    },
    deleteArticle(id) {
      api
        .deleteArticlePriority(id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$store.dispatch('getPriorityArticles', {
            categoryId: parseInt(this.$route.params.id, 10),
          });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
  },
  mounted() {
    this.$store.dispatch('getSimplifiedCategories', {
      sortBy: 'title',
      isSortAscending: true,
      retrieveAll: true,
    });
    this.$store.dispatch(
      'getCategoryById',
      parseInt(this.$route.params.id, 10)
    );
    this.$store.dispatch('getPriorityArticles', {
      categoryId: parseInt(this.$route.params.id, 10),
    });
  },
};
</script>
